import styled from 'styled-components';
import ClampLines from 'react-clamp-lines';

import {
  Image as SemanticImage,
  Icon as SemanticIcon,
  Dropdown as SemanticDropdown,
} from 'semantic-ui-react';

import { Segment as SegmentLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Segment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    cursor: pointer;
    height: 140px;
    max-width: 287px;
    min-width: 287px;
    padding: 15px;
    width: 20%;
  }
`;

export const Title = styled(ClampLines)`
  color: ${(props) => props.theme.color.titleHighlightReels};
  font-size: 18px;
  font-weight: 500;
  word-wrap: break-word;
  margin-bottom: 10px;
`;

export const Description = styled(ClampLines)`
  word-wrap: break-word;
`;

export const DescriptionContainer = styled.div``;

export const Typography = styled(TextLayoutComponent.Span)``;

export const WatchLink = styled.a`
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
`;

export const Dropdown = styled(SemanticDropdown)`
  &&& {
    position: absolute;
    padding: 8px;
    top: 3px;
    right: 10px;
    height: 20px;
    width: 33px;

    &&:hover {
      background: ${(props) => props.theme.color.whtite};
    }

    &.active {
      background: ${(props) => props.theme.color.whtite};
    }

    &.ui.dropdown>.dropdown.icon{
      display: none;
    }

    &.ui.dropdown>.menu>.item {
      width: 94px;
    }
  }
`;

export const DropdownItem = styled(SemanticDropdown.Item)``;

export const Delete = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.textErrorProjetSetUp};
`;

export const Item = styled(TextLayoutComponent)``;

export const Image = styled(SemanticImage)`
  &.ui.image {
    width: 18px;
    height: 4px;
  }
`;

export const Icon = styled(SemanticIcon)`
  &&& {
    margin-left: 5px;
  }
`;
